import { css } from '@emotion/css'
import { spacing, fontSize, fontWeight, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    display: 'flex',
    padding: spacing.default,
    whiteSpace: 'nowrap',
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue,
    borderBottomStyle: 'dashed',
  }),
}

export default styles
